import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule } from '../../../app/guards'

/** Sales commission and technician incentives (ADR-049): part of Sales; every page below needs it. */
export const Route = createFileRoute('/_app/commissions')({
  beforeLoad: ({ context }) => requireModule(context.session, 'sales'),
  component: Outlet,
})
